import {ClassNameMap} from '@packages/systems/style/types';

/**
 * Given a `ClassNameMap` and `styleBlockId`, returns the class name associated with
 * the matching Style Block in `ClassNameMap` or `null` if not found.
 *
 * For class names stored as strings, the value of `classNameMap[styleBlockId]` will be returned.
 * For class names stored with variant state keys, the result of `classNameMap[styleBlockId].name` will be returned.
 */
export const getNameFromClassNameMap = (
  classNameMap: ClassNameMap,
  styleBlockId: string
): string | null => {
  const value = classNameMap[styleBlockId];
  const name = typeof value === 'string' ? value : value?.name;

  return name ?? null;
};
